module.exports = __webpack_public_path__ + "img/how__visual-4@2x.a1394df2.jpg";